import { createAction, props } from '@ngrx/store';

export const setLocalStorage = createAction(
  '[Common] Set Local Storage',
  props<{ key: string, data: any }>()
);

export const setSessionStorage = createAction(
  '[Common] Set Session Storage',
  props<{ key: string, data: any }>()
);

export const clearSessionStorage = createAction(
  '[Common] Clear Session Storage',
  props<{ keys: string[] }>()
);

export const clearLocalStorage = createAction(
  '[Common] Clear Local Storage',
  props<{ keys: string[] }>()
);